import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/AB';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 保戶進入ISAB減少年金保單價值準備金前，取得先前ISAB減少年金保單價值準備金記錄
export function getInfoAB() {
    return get(`${url}/info`);
}

/**
 * sumbit
 */
export function submitAB(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
